import PropTypes from 'prop-types';

const PartiallyComplete = (props) => (
  <span className={props.className}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.8222 5.14451L18.786 3.99588C17.8549 3.20783 16.7935 2.58833 15.6494 2.16528L15.1367 3.57348C16.1165 3.93691 17.0253 4.46857 17.8222 5.14451Z"
        fill="currentColor"
      />
      <path
        d="M20.8557 10.4999L22.3314 10.1903C22.124 8.99193 21.7083 7.83914 21.1032 6.78418L19.8047 7.4999C20.323 8.43291 20.6784 9.44744 20.8557 10.4999Z"
        fill="currentColor"
      />
      <path
        d="M15.1367 20.4265L15.6494 21.8347C16.7935 21.4116 17.8549 20.7921 18.786 20.0041L17.8222 18.8555C17.0253 19.5314 16.1165 20.0631 15.1367 20.4265Z"
        fill="currentColor"
      />
      <path
        d="M19.8047 16.4999L21.1032 17.2499C21.7086 16.1828 22.1244 15.0187 22.3318 13.8095L20.8557 13.5493C20.6782 14.5861 20.3227 15.5844 19.8047 16.4999Z"
        fill="currentColor"
      />
      <path
        d="M12 22.5V1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12C1.5 14.7848 2.60625 17.4555 4.57538 19.4246C6.54451 21.3938 9.21523 22.5 12 22.5Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

PartiallyComplete.defaultProps = {
  className: '',
};

PartiallyComplete.propTypes = {
  className: PropTypes.string,
};

export default PartiallyComplete;
